import React, { useState, useRef, useEffect } from 'react';

import StoryModal from './story-modal';
import { useOutsideClick } from '../../../utils/custom-hooks';
import Icon from '../../ui/icon';

const OptionsModal = ({
  copyLink,
  setShowOptionsModal,
  getStory,
  editStory,
  productName,
  setSnackbarTxt,
}) => {
  const [story, setStory] = useState({});
  const [showStoryModal, setShowStoryModal] = useState(false);

  const ref = useRef(false);
  useOutsideClick(ref, () => setShowOptionsModal(false));

  useEffect(() => {
    fetchEdit();
  }, []);

  async function fetchEdit() {
    const res = await getStory();
    const editData = res.data.data[0];
    setStory(editData);
  }

  function handleCopy(copyText, snackBarTxt) {
    navigator.clipboard.writeText(copyText);
    setSnackbarTxt(snackBarTxt);
    setShowOptionsModal(false);
  }

  async function handleSubmit(params) {
    const updatedStory = await editStory(params);
    setStory(updatedStory);
  }

  const editStoryModal = showStoryModal ? (
    <StoryModal
      action="edit"
      setShowModal={setShowStoryModal}
      story={story}
      handleSubmit={handleSubmit}
    />
  ) : null;

  return (
    <div className="options-modal" ref={node => (ref.current = node)}>
      <div className="option-item" onClick={() => handleCopy(copyLink, 'Link Copied')}>
        <span className="option-name">Copy Narrativ Link</span>
      </div>
      <div className="option-item" onClick={() => handleCopy(productName, 'Product Name Copied')}>
        <span className="option-name">Copy Product Name</span>
      </div>
      {/* TODO readd in v2 */}
      {/* <div className="option-item" onClick={() => setShowStoryModal(true)}>
        <span className="option-name">Edit Post Details</span>
      </div> */}
      {/* {editStoryModal} */}
    </div>
  );
};

const LinkOptions = ({ copyLink, getStory, editStory, productName, setSnackbarTxt }) => {
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const modal = showOptionsModal ? (
    <OptionsModal
      copyLink={copyLink}
      setShowOptionsModal={setShowOptionsModal}
      getStory={getStory}
      editStory={editStory}
      productName={productName}
      setSnackbarTxt={setSnackbarTxt}
    />
  ) : null;

  return (
    <div>
      <div
        className={`link-options ${showOptionsModal ? 'open' : ''}`}
        onClick={() => setShowOptionsModal(!showOptionsModal)}
      >
        <Icon iconName="kebab" size={25} />
      </div>
      {modal}
    </div>
  );
};

export default LinkOptions;
